import React, { FC } from 'react';

import { useTranslation } from 'react-i18next';

import { useIsUpgradeSuggested } from '~/components/layouts/MainLayout/components/ButtonSuggestion/useButtonSuggestion';
import { Button } from '~/design-system/components/Button/Button';
import {
  ButtonSize,
  ButtonVariant,
} from '~/design-system/components/Button/utils';
import { Icon } from '~/design-system/components/Icon/Icon';
import {
  DesignSystemIconSize,
  DesignSystemIconTone,
} from '~/design-system/components/Icon/utils';

import { useHomePageV2HeaderActions } from '../hooks/useHomePageV2HeaderActions';
import styles from '../styles.module.scss';

export const HomePageV2HeaderDesktop: FC = () => {
  const { t } = useTranslation('general');
  const { handleUpgradeClick } = useHomePageV2HeaderActions();
  const isUpgradeSuggested = useIsUpgradeSuggested();

  return (
    <header data-home-v2-header-desktop className={styles.desktop_header}>
      {isUpgradeSuggested && (
        <Button
          data-home-v2-header-upgrade
          variant={ButtonVariant.PRIMARY}
          size={ButtonSize.MEDIUM}
          onClick={handleUpgradeClick}
          StartIcon={() => (
            <Icon
              name="general/upgrade/24"
              size={DesignSystemIconSize.LARGE}
              tone={DesignSystemIconTone.ON_COLOR}
            />
          )}
        >
          {t('upgrade', 'Upgrade')}
        </Button>
      )}
    </header>
  );
};
